import { CamelCaseKeys } from "@utils/typescript";
import { User } from "./User";

export enum UserRoles {
  Customer = 'customer',
  Frontline = 'frontline',
  Insurer = 'insurer',
  Company = 'company',
  Hospital = 'hospital',
  Servicer = 'servicer',
}

export enum UserStatuses {
  Pending = 'pending',
  Confirmed = 'confirmed',
}

export type UserProfile = User & CamelCaseKeys<{
  role: UserRoles;
  status: UserStatuses;
}>;
